<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-12 text-center px-0">
        <div class="row">
          <div class="col-12">
            <div class="float-left back-btn driver-colour font-weight-bold" @click="$_navigationMixin_navigateBack()">
              <i class="fas fa-chevron-circle-left"></i>
              <span> Back</span>
            </div>
          </div>
          <div class="col-12 col-md-8 col-lg-6 m-auto pb-2 png-wrap">
            <ul class="nav nav-fill row">
              <template v-for="item in items_navigation" :key="item.name">
                <li 
                  v-show="item.display" 
                  :class="[
                    'nav-item font-weight-bold nav-breadcrumbs', 
                    'nav-item-' + item.name.toLowerCase(),
                    item.class, 
                    item.link_router == $route.name ? 'active' : '',
                    $_navigationMixin_linkIsDisabled(item) ? 'disabled' :'',
                    $_navigationMixin_itemSelected(item) ? 'selected' :''                  
                  ]">
                  <router-link 
                    class="nav-link" 
                    :to="{ name: item.link_router, params: (store.state.selected_charity.beneficiaryId && store.state.selected_charity.Router_Name == item.link_router) ? {beneficiaryId: store.state.selected_charity.beneficiaryId} : {} }">
                     <i :class="item.faIconClass">&nbsp;</i>{{ item.name }}
                  </router-link>
                </li>
                <li 
                  v-show="item.name != 'Complete' && item.display">
                  <p class="pag-gap d-none d-sm-none d-md-block my-1">----------</p>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 px-0 pt-1">
        <router-view v-slot="{ Component }">
          <component :is="Component">
            <template #terms>
              <slot name="terms"></slot>
            </template>
          </component>
        </router-view>
      </div>
    </div>
  </div>
</template>
<script>
import NavigationMixin from '../inc/NavigationMixin.vue';
import store from '../../store/store';

export default {
  mixins: [ NavigationMixin ],

  data(){
    return{
      store,
      items_navigation:[
        {name: "Cause", faIconClass: "fas fa-ribbon", link_router: "charity_individual", general_router: "charity_team", class: 'gf-ft', display : store.state.data_params_pre.beneficiaryId != '' ? false : true },
        {name: "Event", faIconClass: "far fa-calendar", link_router: "event_individual", general_router: "Event_team", class: "gf-ft", display : store.state.data_params_pre.eventId != '' ? false : true },
        {name: "Complete", faIconClass: "far fa-check-circle", link_router: "complete_individual", general_router: "", class: "gf-ft", display : true }
      ]
    }
  }
}
</script>
